import styled from "styled-components"

export const Wrapper = styled.div`
  display: grid;
  gap: 16px;
`
